import { createConsumer } from '@rails/actioncable'
import { websocketRoot } from './index'

export const AppSocket = {
  consumer: token => {
    return createConsumer(`${websocketRoot}/cable?token=${token}`)
  }
}
